function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.95
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#001854",
  d: "M0 32L127 32 127 0 0 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2D4B97",
  d: "M127 32L211 32 211 0 127 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#00B6E5",
  d: "M211 32L258 32 258 0 211 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D03",
  d: "M258 32L294 32 294 0 258 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFB400",
  d: "M294 32L314 32 314 0 294 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3BBB69",
  d: "M314 32L333 32 333 0 314 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A7C900",
  d: "M333 32L350 32 350 0 333 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#65328B",
  d: "M350 32L363 32 363 0 350 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF2885",
  d: "M363 32L375 32 375 0 363 0z"
})));

var SvgKreski = function SvgKreski(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 32,
    viewBox: "0 0 375 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKreski, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kreski.ddc4bad3.svg";
export { ForwardRef as ReactComponent };